import _config from "../../config/dev";

export const mConfig = {
  root: "#paytm-checkoutjs",
  backButton: true,
  style: {
    // borderColor: "",
    // bodyBackgroundColor: "#ffffff",
    // bodyColor: "#182233",
    // themeBackgroundColor: "#2073d4",
    // themeColor: "#ffffff",
    // headerBackgroundColor: "#F5F9FE",
    // headerColor: "#F5F9FE",
    // errorColor: "",
    // successColor: "",
    // card: {
    //   padding: "",
    //   backgroundColor: ""
    // }
  },
  flow: "DEFAULT",
  redirectionEnabled: true,
  redirect: true,
  labels: {},
  isGradientEffectEnable: false,
  data: {
    orderId: "",
    token: "",
    tokenType: "TXN_TOKEN",
    amount: ""
  },
  merchant: { redirect: true, hidePaytmBranding: false },
  handler: {
    notifyMerchant(eventType, data) {
      console.log("notify merchant called", eventType, data);
    }
  }
};

const buildPayload = payload => {
  const { body } = payload;
  return JSON.stringify({
    head: {
      timestamp: "1539601338741",
      clientId: "78yds87ty7ds",
      version: "v2",
      channelId: "WEB",
      // tokenType: "AES" | "JWT",
      tokenType: "AES",
      signature: "jhddyt87td87vd"
    },
    body
  });
};

export const generateTxnToken = (url, payload) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: buildPayload(payload)
  })
    .then(resp => resp.json())
    .then(jsonResp => {
      return new Promise((resolve, reject) => {
        if (jsonResp) {
          resolve(jsonResp);
        } else {
          reject(jsonResp);
        }
      });
    })
    .catch(error => {
      console.log(error);
      return Promise.reject(error);
    });
};



// WEBPACK FOOTER //
// ./utils/checkout.js